const ERROR_HASH = '#external_password_incorrect';

export default {
  computed: {
    isIssetCutomerAlbums() {
      return localStorage.getItem('customerItems')
    }
  },
  methods: {
    getThumbnail(item) {
      return item.primary_photo
          ? item.primary_photo.medium_photo
          : item.first_photo
              ? item.first_photo.medium_photo
              : null;
    },
  },
  created() {
    if (location.hash === ERROR_HASH || !this.customerAlbums || this.customerAlbums && !this.customerAlbums.length) {
      this.$bvToast.toast(this.$t(location.hash === ERROR_HASH ? 'messages.album_not_found' : 'messages.no_my_photos'), {
        variant: 'danger',
        toaster: 'b-toaster-bottom-center',
        toastClass: 'toast--lock',
        noAutoHide: true,
      });
    }
  }
};
